<script setup lang="ts">
import { defineProps } from 'vue';

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';

import { useDeleteCalculationSegment } from '../composables/useDeleteCalculationSegment';

defineProps<{
  calculationUuid: string;
  segmentId: number;
}>();

const { visible, isLoading, deleteCalculationSegment } = useDeleteCalculationSegment();
</script>

<template>
  <Dialog
    v-model:visible="visible"
    class="[&__.p-dialog-header]:pb-2"
    header="Czy na pewno chcesz usunąć technologię?"
    :style="{ width: '35rem' }"
  >
    <p class="mb-4 text-sm">
      Ta operacja jest nieodwracalna. Usunięcie tej technologii spowoduje utratę wszystkich
      powiązanych z nią danych. Czy na pewno chcesz kontynuować?
    </p>

    <div class="flex justify-center gap-4">
      <Button size="small" severity="secondary" outlined @click="visible = false"> Anuluj </Button>
      <Button
        size="small"
        :loading="isLoading"
        @click="deleteCalculationSegment(calculationUuid, segmentId)"
      >
        Usuń
      </Button>
    </div>
  </Dialog>

  <Button class="!p-2" size="small" severity="secondary" outlined @click="visible = true">
    <i class="pi pi-trash"></i>
  </Button>
</template>
